import b from "@emotion/styled/base";
import { TransparencyEnum as g } from "@partoohub/branding";
const C = /* @__PURE__ */ b("label", process.env.NODE_ENV === "production" ? {
  target: "e1j0c2x70"
} : {
  target: "e1j0c2x70",
  label: "SelectableCardContainer"
})(({
  theme: I
}) => `
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    border-radius: ${I.radius.large};
    border: 1px solid ${I.colors.default.alpha};
    box-shadow: 0px 0px 0px 0px transparent;

    /* Make the text non-selectable */
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;

    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    &[aria-checked="true"] {
        border-color: ${I.colors.primary.initial};
        box-shadow: 0px 0px 0px 3px ${I.colors.primary.alpha};
        ::before {
            content: '';
            position: absolute;
            top: -1px;
            right: -1px;
            bottom: -1px;
            left: -1px;
            border: 2px solid ${I.colors.primary.initial};
            border-radius: ${I.radius.large};
        }
    }


    &[aria-disabled="true"] {
        opacity: ${g.DISABLED};
        cursor: default;
        pointer-events: none;
    }

    &[aria-checked="false"][aria-disabled="false"]:hover {
        border-color: ${I.colors.default.initial};
    }
`, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
export {
  C as SelectableCardContainer
};
